import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,//是否登录
    userInfo: {},//用户信息
    token: ""
  },
  getters: {
  },
  mutations: {
    // 是否已登录
    changeLoginstore(state, provider) {
      state.isLogin = provider;
    },
    // 存储用户信息
    saveUserInfo(state, provider) {
      state.userInfo = provider;
    },
    // 存储用户登录token信息
    saveTokenInfo(state, provider) {
      state.token = provider;
    },
    // 更新token信息
    updateToken(state, provider) {
      state.token = provider
    },
    // 退出登录
    logout(state) {
      state.isLogin = false;
      state.token = "";
      state.userInfo = {};
      // 移除缓存
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
      localStorage.removeItem('isLogin')
    },
  },
  actions: {
  },
  modules: {
  }
})
